<template>
	<div style="position: relative;box-sizing: border-box;padding: 10px;min-height: 100%;">

		<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="data" collapse
			@item-click="itemClick" :klass="klass" v-if="data.length!=0" :item-events="itemEvents" v-loading="loading"></v-jstree>	
			
		<div>
			<contextmenu :contextMenuData="contextMenuData" @addNode="addNode" @editNode="editNode"
				@editKpi="editKpi" @deleteNode="deleteNode" @importgoodscode="importgoodscode"
				@cleargoodscode="cleargoodscode" v-if="menuShow">
			</contextmenu>
		</div>	
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				data: [],
				datasource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
				klass: '',
				menuShow:false,
				contextMenuData: {
					menuName: 'edgeMenu',
					axis: {
						x: null,
						y: null
					},
					menulists: [{
							btnName: "KPI配置",
							fnHandler: "editKpi",
							icoName: "el-icon-edit-outline"
						}, {
							btnName: "添加",
							fnHandler: "addNode",
							icoName: "el-icon-edit-outline"
						}, {
							btnName: "编辑",
							fnHandler: "editNode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "导入商品编码",
							fnHandler: "importgoodscode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "清空商品编码",
							fnHandler: "cleargoodscode",
							icoName: "el-icon-edit-outline"
						},
						{
							btnName: "删除",
							fnHandler: "deleteNode",
							icoName: "el-icon-delete"
						}
					]
				},
				itemEvents: {
					mouseover: (e) => {
						this.currentItem = e.model
						this.klass = 'menuoverClass'
				
					},
					mouseleave: () => {
						//console.log(e.model)
						this.klass = ''
					},
					contextmenu: (component, model, event) => {
						this.onContextmenu(event, model)
						event.preventDefault()
					}
				},
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.modulelist = []
				this.$api.goodsrevenueinfo.list().then((res) => {
					let data = JSON.parse(JSON.stringify(res.list))
					data.forEach((item) => {
						item.name = item.revenueName
						item.parentid = 0
						item.icon = ''
					})
					let root = []
					let rootnode = {
						id: '-1',
						name: '收藏分类',
						parentid: 0,
						opened: true,
						children:[]
					}
					root.push(rootnode)
					let group = this.$Lodash.groupBy(data,'shortName')
					for(let i in group){
						let shortName = {
							id: i,
							name: i,
							parentid: '-1',
							opened: true,
							children:[]
						}
						group[i].forEach((item)=>{
							item.parentid = i
						})
						shortName.children = group[i]
						rootnode.children.push(shortName)
						
					}		
					//console.log(root)
					this.data = root
					this.datasource = res.list
					this.loading = false
				})
			},
			itemClick(node, item, e) {
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentid: item.parentid,
					childrenid: item.childrenid,
					datasource: this.datasource

				})
				e.stopPropagation()
			},
			onContextmenu(event, model) {
				let items = [{
						label: "取消收藏",
						onClick: () => {
							this.collect(model)
						}
					}
				]
				this.$contextmenu({
					items: items,
					event,
					//x: event.clientX,
					//y: event.clientY,
					customClass: "custom-class",
					zIndex: 9999999,
					minWidth: 150
				});
				return false;
			},
			collect(e){
				this.$api.goodsrevenueinfo.collect({id:e.id,collect:0}).then(()=>{
					this.$emit('flashtree')
					this.$message.success('操作成功')
				})	
			},
		},
		components: {
			VJstree
		}
	}
</script>